import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import {
  Card,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Slider,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDAvatar from "components/MDAvatar";
import { getUserInfo } from "services/apiService";
import { getListCampaigns } from "services/apiService";
import { uploadPost } from "services/apiService";
import MDInput from "components/MDInput";
import dialogBgImage from "assets/images/dialogBgImage.png";
import uploadImg from "assets/images/uploadImg.png";
import { useRef } from "react";
import validations from "customValidations/validations";
import validationService from "customValidations/validationService";
import CircularProgress from "@mui/material/CircularProgress";
import { useMediaQuery } from "react-responsive";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { IconButton, InputAdornment } from "@mui/material";
import { toast } from "react-toastify";
import Moment from "react-moment";
import moment from "moment";
import Cropper from "react-easy-crop";

import { generateVideoThumbnails } from "@rajesh896/video-thumbnails-generator";
import { useDispatch, useSelector } from "react-redux";
import { campaignReducer } from "Store/slices/campaignSlice";
import { fetchFeed } from "Store/slices/userFeedSlice";

function CreatePost({ openStatus, onClose, isParticipate, participateData }) {
  const dispatch = useDispatch();
  const { userAppInfo, isLoadingInfo } = useSelector((state) => state.userInfo);
  const { campaignList, campaignLoading, campaignPageNumber } = useSelector(
    (state) => state.campaigns
  );
  let navigate = useNavigate();
  const inputFile = useRef(null);
  // const [duration, setDuration] = useState(0);
  const [testOpen, setTestOpen] = useState(false);
  const [userInfo, setUserInfo] = useState([]);
  const [campList, setCampList] = useState([]);
  const [campaign, setCampaign] = useState("");
  const [description, setDescription] = useState("");
  const [img, setImg] = useState("");
  const [imgSrc, setImgSrc] = useState("");
  const [videoSrc, setVideoSrc] = useState("");
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [minZoom, setMinZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImgSrc, setCroppedImgSrc] = useState("");
  const [croppedImgFile, setCroppedImgFile] = useState("");
  const [thumbnailFile, setThumbnailFile] = useState("");
  const [cropBox, setCropBox] = useState(false);
  const [videoBox, setVideoBox] = useState(false);
  const [loading, setLoading] = useState(false);
  const [startTrim, setStartTrim] = useState(0);
  const [endTrim, setEndTrim] = useState(0);
  const [postType, setPostType] = useState("image");

  const [errorMsg, setErrorMsg] = useState({
    description: { errorMsg: "" },
  });
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  useEffect(() => {
    // fetchUserInfo();
    fetchParticipationData();
    // fetchCampaignList();
  }, []);

  const fetchUserInfo = async () => {
    const userInfoRes = await getUserInfo(localStorage.userNameSingh);
    // console.log("userInfoRes", userInfoRes);
    setUserInfo(userInfoRes);
  };

  const fetchParticipationData = () => {
    if (isParticipate) {
      // setCroppedImgSrc(participateData.campaignImage);
      setCampaign(participateData);
    }
  };

  const fetchCampaignList = async () => {
    // if (campaignLoading) {
    //   const campaignListRes = await getListCampaigns(campaignPageNumber);
    //   dispatch(campaignReducer(campaignListRes));
    // }
    // const campaignList = await getListCampaigns(1);
    // // console.log("campList", campaignList);
    // setCampList(campaignList);
  };

  const customValidations = (name, value) => {
    let errorLength = 0;
    const args = [
      {
        name,
        value: value,
        validations: validations.createPostValidations[name],
      },
    ];

    validationService.validate(args, (validationErr, validationErrMsgs) => {
      if (validationErrMsgs.length > 0) {
        errorLength = errorLength + 1;
        errorMsg[name].errorMsg = validationErrMsgs[0].validations[0].message;
        setErrorMsg({ ...errorMsg });
      } else {
        errorMsg[name].errorMsg = "";
        setErrorMsg({ ...errorMsg });
      }
    });
    return errorLength;
  };

  const handleImageClick = () => {
    inputFile.current.click();
  };

  const handleSelect = (value) => {
    // console.log("V", value);
    setCampaign(value);
  };

  const handleInputChange = (value) => {
    setDescription(value);
  };

  const handleBrowse = (e) => {
    if (!e.target.files[0]) {
      return;
    }
    const file = e.target.files[0];
    const fileType = file.type.split("/")[0];
    if (fileType === "image") {
      setImg(file);
      const reader = new FileReader();
      reader.onload = function (e) {
        setImgSrc(e.target.result); // set the dataURL
        setPostType("image");
        setCropBox(true);
      };
      reader.readAsDataURL(file);
    } else if (fileType === "video") {
      if (file.size > 100000000) {
        toast.warning(`Video size should be less than 100mb`, {
          style: {
            fontSize: "12px",
          },
        });
        return;
      }
      setCroppedImgFile(file);
      generateVideoThumbnails(file, 0)
        .then((thumbnailArray) => {
          const fileName = file.name.replace(/\.[^/.]+$/, "");

          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          const img = new Image();
          img.src = thumbnailArray[0];
          img.onload = function () {
            canvas.width = img.width / 5;
            canvas.height = img.height / 5;
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            canvas.toBlob(
              (blob) => {
                const thumbnailFile = new File([blob], fileName, {
                  type: "image/jpeg",
                });
                setThumbnailFile(thumbnailFile);
              },
              "image/jpeg",
              1
            );
          };

          // fetch(thumbnailArray[0])
          //   .then((response) => response.blob())
          //   .then((thumbnailUrltoFile) => {
          //     const thumbnailFile = new File([thumbnailUrltoFile], fileName, {
          //       type: "image/jpeg",
          //       size: file.size / 10,
          //       // lastModified: new Date(),
          //     });
          //     setThumbnailFile(thumbnailFile);
          //   })
          //   .catch((err) => console.log(err));

          setThumbnailFile(thumbnailFile);
          setCroppedImgSrc(thumbnailArray[0]);
          setPostType("video");
        })
        .catch((err) => {
          console.error(err);
          toast.warning(`Something went wrong, please try again`, {
            style: {
              fontSize: "12px",
            },
          });
        });
    }
  };

  const handlePost = async () => {
    let errorLengthDescription = customValidations("description", description);

    if (errorLengthDescription === 1) {
      return;
    }
    if (postType === "image") {
      if (img === "") {
        // onClose();
        // Swal.fire({
        //   icon: "warning",
        //   title: "Please upload image",
        // });
        toast.warning(`Please upload image`, {
          style: {
            fontSize: "12px",
          },
        });
        return;
      }
    }

    setLoading(true);
    // console.log("campaign", campaign._id);
    let postData = new FormData();
    // console.log("TestIMG", croppedImgFile);
    postData.append("post", croppedImgFile); //img or video

    if (postType === "video") {
      postData.append("thumbnail", thumbnailFile); //videothumbnail
    }

    postData.append("caption", description);
    postData.append("campaignID", campaign._id ? campaign._id : "");
    postData.append("postType", postType); //imageorvideo
    postData.append(
      "datetime",
      moment(Date.now()).format("YYYY-MM-DD HH:mm:ss.sss")
    );

    const postRes = await uploadPost(postData);
    // console.log("postRes", postRes);
    onClose(); // to trigger onClose funtion of dialog written in sidenav

    if (postRes.status === 200) {
      console.log("here");
      dispatch(fetchFeed(1));
      toast.success(`Post created`, {
        style: {
          fontSize: "12px",
        },
      });

      navigate(`/`);

      // navigate(
      //   `/profile-post-detail/?username=${localStorage.userNameSingh}&type=post&postId=${postRes.data[0]._id}`
      // );

      // Swal.fire("Post created succesfully", "", "success");

      setLoading(false);
    } else {
      toast.error(`Oops! something went wrong, please try again`, {
        style: {
          fontSize: "12px",
        },
      });
      setLoading(false);
    }
  };

  // const handleBack = () => {
  //   navigate(-1);
  // };
  // const getCroppedImg = (file, pixelCrop) => {
  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.onload = (event) => {
  //       const img = new Image();
  //       img.onload = () => {
  //         const canvas = document.createElement("canvas");
  //         canvas.width = pixelCrop.width;
  //         canvas.height = pixelCrop.height;
  //         const ctx = canvas.getContext("2d");
  //         ctx.drawImage(
  //           img,
  //           pixelCrop.x,
  //           pixelCrop.y,
  //           pixelCrop.width,
  //           pixelCrop.height,
  //           0,
  //           0,
  //           pixelCrop.width,
  //           pixelCrop.height
  //         );
  //         resolve(canvas.toDataURL("image/jpeg"));
  //       };
  //       img.src = event.target.result;
  //     };
  //     reader.readAsDataURL(file);
  //   });
  // };
  const getCroppedImg = (originalImg, pixelCrop) => {
    // console.log("Test1");
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = pixelCrop.width;
          canvas.height = pixelCrop.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(
            img,
            pixelCrop.x,
            pixelCrop.y,
            pixelCrop.width,
            pixelCrop.height,
            0,
            0,
            pixelCrop.width,
            pixelCrop.height
          );
          canvas.toBlob((blob) => {
            const fileName = originalImg.name.replace(/\.[^/.]+$/, "");
            const file = new File([blob], fileName, {
              type: "image/png",
            });
            resolve({ dataUrl: canvas.toDataURL("image/png"), file });
          }, "image/png");
        };
        img.src = event.target.result;
      };
      reader.readAsDataURL(originalImg);
    });
  };

  // const onCropComplete = async (croppedArea, croppedAreaPixels) => {
  //   console.log("CP", croppedAreaPixels);
  //   const newImg = await getCroppedImg(img, croppedAreaPixels);
  //   console.log("new", newImg);
  //   setCroppedImgSrc(newImg);

  // };

  const onCropComplete = async (croppedArea, croppedAreaPixels) => {
    // console.log("Test");
    const { dataUrl, file } = await getCroppedImg(img, croppedAreaPixels);
    setCroppedImgSrc(dataUrl);
    setCroppedImgFile(file);
  };

  const onCropChange = (crop) => {
    setCrop(crop);
  };

  const onZoomChange = (zoom) => {
    setZoom(zoom);
  };

  const onRotationChange = (rotation) => {
    setRotation(rotation);
  };

  // const onImageLoaded = (image) => {
  //   if (image.width < 400 && image.height < 400) {
  //     setMinZoom(1);
  //   }
  // };

  const zoomPercent = (value) => {
    return `${Math.round(value * 100)}%`;
  };

  const onBackDropClickCropBox = () => {
    setImg("");
    setImgSrc("");
    setCroppedImgSrc("");
    setCropBox(false);
  };

  const cropBoxSave = () => {
    setCropBox(false);
  };

  return (
    <>
      <Dialog
        name="imageDialog"
        open={cropBox}
        maxWidth="md"
        fullWidth={true}
        // fullScreen={isTabletOrMobile && true}
        onClose={onBackDropClickCropBox}
      >
        <MDBox
          sx={{
            padding: "1rem",
            backgroundColor: "#000",
            border: "1px solid #F2CB2E",
          }}
        >
          <DialogContent
            sx={{
              margin: 0,
              padding: 0,
              // display: "flex",
              // justifyContent: "center",
            }}
          >
            <MDBox
              sx={{
                // border: "1px solid red",
                position: "relative",
                height: "300px",
                // width: "500px",
                width: "auto",
                // width: "300px",
              }}
            >
              <Cropper
                image={imgSrc}
                crop={crop}
                zoom={zoom}
                rotation={rotation}
                minZoom={1}
                aspect={1}
                onZoomChange={onZoomChange}
                onRotationChange={onRotationChange}
                onCropChange={onCropChange}
                onCropComplete={onCropComplete}
                // onWheel={(e) => e.preventDefault()}
                // disableScroll={true}
                // onImageLoaded={onImageLoaded}
              />
            </MDBox>
          </DialogContent>
          <DialogActions
            sx={{
              padding: 0,
              margin: 0,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <MDBox sx={{ width: "80%" }}>
              <MDBox sx={{ width: "100%", textAlign: "center" }}>
                <MDTypography color="text">
                  Zoom:{zoomPercent(zoom)}{" "}
                </MDTypography>
                <MDBox
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "30px",
                  }}
                >
                  <Slider
                    valueLabelDisplay="auto"
                    valueLabelFormat={zoomPercent}
                    min={1}
                    max={3}
                    step={0.1}
                    value={zoom}
                    onChange={(e, zoom) => setZoom(zoom)}
                  />
                  <IconButton color="inherit" onClick={() => setZoom(1)}>
                    <RestartAltIcon fontSize="inherit" />
                  </IconButton>
                </MDBox>
              </MDBox>
              <MDBox sx={{ width: "100%", textAlign: "center" }}>
                <MDTypography color="text">Rotation:{rotation}%</MDTypography>
                <MDBox
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "30px",
                    // justifyContent: "center",
                  }}
                >
                  <Slider
                    valueLabelDisplay="auto"
                    // valueLabelFormat={zoomPercent}
                    min={0}
                    max={360}
                    step={0.1}
                    value={rotation}
                    onChange={(e, rotation) => setRotation(rotation)}
                  />

                  <IconButton
                    color="inherit"
                    onClick={() =>
                      rotation === 360
                        ? setRotation(0)
                        : setRotation((prev) => prev + 90)
                    }
                  >
                    <RotateRightIcon fontSize="inherit" />
                  </IconButton>
                </MDBox>
              </MDBox>
              <MDBox
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-around",
                }}
              >
                <MDButton
                  color="singh"
                  onClick={onBackDropClickCropBox}
                  variant="outlined"
                >
                  Cancel
                </MDButton>
                <MDButton
                  color="singh"
                  variant="outlined"
                  onClick={cropBoxSave}
                >
                  Save
                </MDButton>
              </MDBox>
            </MDBox>
          </DialogActions>
        </MDBox>
      </Dialog>

      {/* <Dialog
        name="videoDialog"
        open={videoBox}
        maxWidth="md"
        fullWidth={true}
        // fullScreen={isTabletOrMobile && true}
        onClose={onBackDropClickCropBox}
      >
        <MDBox
          sx={{
            height: "500px",
            padding: "1rem",
            backgroundColor: "#000",
            border: "1px solid #ff9607",
          }}
        >
          <DialogContent>
            <video id="video" src={videoSrc} controls />
          </DialogContent>
        </MDBox>
      </Dialog> */}

      <Dialog
        open={openStatus}
        maxWidth="lg"
        fullScreen={isTabletOrMobile && true}
        onClose={onClose}
      >
        {/* {isTabletOrMobile &&  */}
        <MDBox
          sx={{
            border: isDesktopOrLaptop && "1px solid #F2CB2E",
            borderRadius: isDesktopOrLaptop && "8px",
            backgroundColor: "#1a1a1a",
            // backgroundImage: `url(${dialogBgImage})`,
            // backgroundRepeat: "no-repeat",
            // backgroundSize: "cover",
            // backgroundPosition: isTabletOrMobile && "bottom",
          }}
        >
          <DialogTitle>
            <MDBox sx={{ display: "flex", justifyContent: "space-between" }}>
              {isTabletOrMobile && (
                <IconButton
                // onClick={() => handleBack()}
                >
                  <IconButton onClick={onClose} color="white" fontSize="30px">
                    <ArrowBackIcon />
                  </IconButton>
                </IconButton>
              )}

              <MDBox>
                <MDTypography
                  fontWeight="bold"
                  color="singh"
                  sx={{
                    fontSize: isTabletOrMobile ? "20px" : "40px",
                    marginRight: isTabletOrMobile && "120px",
                    marginTop: isTabletOrMobile && "15px",
                  }}
                >
                  Create Post
                </MDTypography>
              </MDBox>

              {isDesktopOrLaptop && (
                <MDBox sx={{ display: "flex", alignItems: "center" }}>
                  <MDTypography
                    fontWeight="bold"
                    fontSize="15px"
                    sx={{ color: "#6a6a6a" }}
                  >
                    {userAppInfo?.username}
                  </MDTypography>
                  &nbsp;&nbsp;
                  <MDAvatar
                    src={userAppInfo?.profilePic}
                    imgProps={{ style: { height: "100%", width: "100%" } }}
                  />
                </MDBox>
              )}
            </MDBox>
          </DialogTitle>
          <DialogContent>
            <Grid container sx={{}}>
              <Grid
                item
                container
                xs={12}
                md={6}
                sx={{ justifyContent: "center" }}
              >
                <MDBox
                  sx={{
                    height: isTabletOrMobile ? "270px" : "230px",
                    width: isTabletOrMobile ? "270px" : "500px",
                    marginRight: isDesktopOrLaptop && "8px",
                    border: "2px dashed #6a6a6a",
                    cursor: "pointer",
                    borderRadius: "12px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    "&:hover": {
                      backgroundColor: "#000",
                    },
                  }}
                  onClick={() => handleImageClick()}
                >
                  {croppedImgSrc ? (
                    <img
                      style={{
                        objectFit: "cover",
                        width: "100%",
                        height: "100%",
                        borderRadius: "10px 10px 10px 10px",
                      }}
                      src={croppedImgSrc}
                      alt="logo"
                      onClick={() => handleImageClick()}
                    />
                  ) : (
                    <img
                      style={{
                        width: isTabletOrMobile ? "66%" : "55%",
                        height: isTabletOrMobile ? "36%" : "40%",
                      }}
                      src={uploadImg}
                      alt="logo"
                      // onClick={handleImageClick}
                    />
                  )}
                  <MDInput
                    type="file"
                    style={{ display: "none" }}
                    inputProps={{ ref: inputFile, accept: "image/*,video/*" }}
                    onChange={(e) => handleBrowse(e)}
                  />
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} sx={{ padding: "10px" }}>
                <MDBox>
                  <MDBox
                    sx={{
                      marginBottom: isTabletOrMobile ? "0px" : "20px",
                      marginTop: isTabletOrMobile ? "35px" : "0",
                    }}
                  >
                    {isParticipate ? (
                      <TextField
                        fullWidth
                        disabled
                        value={campaign.campaignName}
                        label="Select Campaign"
                      />
                    ) : (
                      <TextField
                        fullWidth
                        select={true}
                        // disabled={campList.length === 0}

                        value={campaign}
                        label="Select Campaign"
                        // InputLabelProps={{ style: { color: "#fff" } }}
                        onChange={(e) => handleSelect(e.target.value)}
                      >
                        <MenuItem value={"None"}>None</MenuItem>
                        {campaignList.map((item, idx) => (
                          <MenuItem key={idx} value={item}>
                            {item.campaignName}
                          </MenuItem>
                        ))}
                      </TextField>
                    )}
                  </MDBox>
                  <MDBox
                    sx={{
                      marginBottom: isTabletOrMobile ? "80px" : "0px",
                      marginTop: isTabletOrMobile && "64px",
                    }}
                  >
                    <TextField
                      fullWidth
                      placeholder="eg:more info about this post"
                      multiline
                      rows={6}
                      color="white"
                      label="Description"
                      value={description}
                      error={errorMsg.description.errorMsg.length > 0}
                      onChange={(e) => handleInputChange(e.target.value)}
                      helperText={errorMsg.description.errorMsg}
                    />
                  </MDBox>
                </MDBox>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <MDButton
              disabled={loading}
              color="singh"
              sx={{ minWidth: isTabletOrMobile ? "100%" : "180px" }}
              onClick={() => handlePost()}
            >
              <MDTypography fontWeight="bold" fontSize="20px">
                {loading ? (
                  <CircularProgress size={30} color="inherit" />
                ) : (
                  "Create Post"
                )}
              </MDTypography>
            </MDButton>
          </DialogActions>
        </MDBox>
      </Dialog>
    </>
  );
}

export default CreatePost;
